var _path, _path2, _path3, _line, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0L24.4318 0L44 0C47.3137 0 50 2.68629 50 6V44C50 47.3137 47.3137 50 44 50H6C2.68629 50 0 47.3137 0 44L0 6Z",
    fill: "#21FCC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2953 23.5326C14.518 22.2198 14.5646 20.5956 15.4156 19.3453L20.2541 12.2365C21.0509 11.0658 22.4282 10.4078 23.8675 10.5102L30.1351 10.9561C31.4789 11.0517 32.6931 11.7977 33.3727 12.9454L42.9619 29.1391C44.0875 31.04 43.4394 33.4594 41.5143 34.5431L30.2257 40.8976C28.3006 41.9813 25.8275 41.3188 24.7019 39.418L15.2953 23.5326Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.9715C11 18.8433 11.4764 17.7676 12.3118 17.0095L20.969 9.15234C21.6995 8.48928 22.8045 8.45804 23.5714 9.07877L32.5166 16.3193C33.4549 17.0788 34 18.2213 34 19.4284V38C34 40.2091 32.2091 42 30 42H15C12.7909 42 11 40.2091 11 38L11 19.9715Z",
    fill: "#155A57"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 19.394,
    y2: -1,
    transform: "matrix(0.721355 -0.692566 0.710601 0.703595 16 35.175)",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9717,
    cy: 22.418,
    rx: 2.27592,
    ry: 1.85282,
    fill: "#FEFEFE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2759,
    cy: 32.1528,
    rx: 2.27592,
    ry: 1.85282,
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReward);
export default __webpack_public_path__ + "static/media/icon-reward.e263ca02eac98a364f38ed03128b321a.svg";
export { ForwardRef as ReactComponent };